// import React, { useState, useEffect } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import * as XLSX from "xlsx";

// // Set up PDF.js worker - adjust the path as needed for your project setup
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const FileViewer = ({ fileUrl }) => {
//   const [fileContent, setFileContent] = useState(null);
//   const fileType = fileUrl.split(".").pop();
//   const [numPages, setNumPages] = useState(null);

//   useEffect(() => {
//     switch (fileType) {
//       case "xlsx":
//         fetch(fileUrl)
//           .then((resp) => resp.arrayBuffer())
//           .then((buffer) => {
//             const workbook = XLSX.read(buffer, { type: "buffer" });
//             const sheetName = workbook.SheetNames[0];
//             const worksheet = workbook.Sheets[sheetName];
//             const html = XLSX.utils.sheet_to_html(worksheet);
//             setFileContent(<div dangerouslySetInnerHTML={{ __html: html }} />);
//           })
//           .catch((err) => console.error("Error reading xlsx file:", err));
//         break;
//       case "pdf":
//         setFileContent(
//           <Document
//             file={fileUrl}
//             onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//             onError={(error) => console.error("Error loading PDF:", error)}
//           >
//             {Array.from(new Array(numPages), (el, index) => (
//               <Page key={`page_${index + 1}`} pageNumber={index + 1} />
//             ))}
//           </Document>
//         );
//         break;
//       case "jpg":
//       case "png":
//         setFileContent(<img src={fileUrl} alt="Document" style={{ width: "100%" }} />);
//         break;
//       default:
//         setFileContent(<p>Unsupported file type</p>);
//     }
//   }, [fileUrl, fileType, numPages]);

//   return <div className="file-viewer">{fileContent || <p>Loading...</p>}</div>;
// };

// export default FileViewer;

import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import * as XLSX from "xlsx";

// Set up PDF.js worker - adjust the path as needed for your project setup
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FileViewer = ({ fileUrl }) => {
  const [fileContent, setFileContent] = useState(null);
  const fileType = fileUrl.split(".").pop();
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    setFileContent(null); // Clear previous content
    setNumPages(null); // Reset number of pages for PDF files

    switch (fileType) {
      case "xlsx":
        fetch(fileUrl)
          .then((resp) => resp.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              const buffer = e.target.result;
              const workbook = XLSX.read(buffer, { type: "buffer" });
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              // Remove editable attributes if any
              const html = XLSX.utils.sheet_to_html(worksheet, {
                editable: false, // Ensure this is set to false to make table read-only
              });
              setFileContent(<div dangerouslySetInnerHTML={{ __html: html }} />);
            };
            reader.readAsArrayBuffer(blob);
          })
          .catch((err) => console.error("Error reading xlsx file:", err));
        break;
      case "pdf":
        setFileContent(
          <Document
            file={fileUrl}
            options={{ cMapUrl: "cmaps/", cMapPacked: true }}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            onError={(error) => console.error("Error loading PDF:", error)}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        );
        break;
      case "jpg":
      case "png":
        setFileContent(<img src={fileUrl} alt="Document" className="image-container" />);
        break;
      default:
        setFileContent(<p>Unsupported file type</p>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUrl, fileType]); // Removed numPages from dependencies to prevent reruns from that state change

  return <div className="file-viewer">{fileContent || <p>Loading...</p>}</div>;
};

export default FileViewer;
